import moment from 'moment'
import Select from 'react-select'
import { toast } from 'react-toastify'
import { MdAdd } from "react-icons/md"
import DatePicker from "react-datepicker"
import Modal from 'react-bootstrap/Modal'
import { IoSearch } from 'react-icons/io5'
import { ClipLoader } from "react-spinners"
import { RiRefreshLine } from 'react-icons/ri'
import WindowedSelect from 'react-windowed-select'
import React, { useState, useEffect } from 'react'
import "react-datepicker/dist/react-datepicker.css"
import LeaseApiService from '../../services/apiService'
import { FaSave, FaChevronLeft, FaEdit, FaTrash } from "react-icons/fa";
import { useSelector } from 'react-redux'
import { getUserName } from '../../../Redux/selecters'
import { useLocation, useNavigate } from 'react-router-dom'
import { useCurrency } from '../../../INVENTORY/Layouts/currencyContext';

const LeaseGeneralInvoiceEdit = ({ show = true, onClose, onSaved, rowData: rowDataProp }) => {
    const apiService = new LeaseApiService();
    const { currencyPrecision } = useCurrency();
    const [taxList, setTaxList] = useState([])
    const [loader, setloader] = useState(false)
    const [unitList, setUnitList] = useState([])
    const [activeTab, setActiveTab] = useState(0);
    const [proprtyList, setProperty] = useState([])
    const [periodFrom, setPeriodFrom] = useState("")
    const [tenantList, setTenantList] = useState([])
    const [voucherList, setVoucherList] = useState([])
    const [accountList, setAccountList] = useState([])
    const [currencyList, setCurrencyList] = useState([])
    const [contextMenu, setContextMenu] = useState(null)
    const [searchModal, setSearchModal] = useState(false)
    const [previewImage, setPreviewImage] = useState(null)
    const [previewModal, setPreviewModal] = useState(false)
    const [TransectionList, setTransectionList] = useState([])
    const [selectedTenant, setSelectedTenant] = useState(null)
    const [SelectedCurrency, setSelectedCurency] = useState([])
    const [gridVisibility, setGridVisibility] = useState([true, false, false])
    const [attachmentList, setAttachmentList] = useState([{ id: Date.now(), fileName: '', remarks: '' }])
    const transactionData = [{ accountCode: '', accountName: '', credit: '0.000', tax: 'None', vat: '0.000', total: '0.000', narration: '' }]
    const [taxInclusive, setTaxInclusive] = useState(false);
    const [activeFY, setActiveFY] = useState(null);
    const userName = useSelector(getUserName);
    const navigate = useNavigate();
    const location = useLocation();
    const itemData = rowDataProp || location.state;
    const handleBackClick = () => {
        if (onClose) {
            onClose();
        } else {
            navigate("/Property/Management/Lease/GeneralInvoice/listing");
        }
    };

    const [formData, setFormData] = useState({
        Proprty: [{ label: 'Select Property', value: '' }],
        unitNo: [{ label: 'Select Unit No', value: '' }],
        tenantName: [{ label: 'Select Tenant', value: '' }],
        tenantNo: [{ label: 'Select Account Code', value: '' }],
    })
    const [TenantData, setTenantData] = useState([{
        LeaseNo: "",
        Property_name: "",
        Unit_No: "--",
        rent: "--",
        TenantNo: "",
        TenantName: "",
        contactNo: "",
    }])
    const [gridList, setGridList] = useState({
        tanentNo: "",
        transectionDate: "",
        tenantName: "",
        conRate: "",
        voucherType: "",
        Proprty: "",
        fxAmount: "",
        transectionType: "",
        unitNo: "",
        amountDr: "",
        taxCode: "",
        leaseNo: "",
        narration: "",
    })
    const [transactionColDefs, setTransactionColDefs] = useState([{
        AccountCode: "",
        AccountName: "",
        credit: "",
        taxCode: "",
        vat: "",
        total: "",
        creditAmount: "",
        narration: "",
    }])
    const total = transactionColDefs?.reduce((sum, item) => sum + parseFloat(item.total || 0), 0)?.toFixed(currencyPrecision?.decimalNumbers);
    const vat = transactionColDefs?.reduce((sum, item) => sum + parseFloat(item.vat || 0), 0)?.toFixed(currencyPrecision?.decimalNumbers);
    const credit = transactionColDefs?.reduce((sum, item) => sum + parseFloat(item.creditAmount || 0), 0)?.toFixed(currencyPrecision?.decimalNumbers);
    useEffect(() => {
        const financialYears = JSON.parse(localStorage.getItem('financialYear')) || [];
        const activeFinancialYear = financialYears?.find(fy => fy.isActive);
        if (activeFinancialYear) {
            setActiveFY(activeFinancialYear.name);
        }
    }, [])
    useEffect(() => {
        fetchDropdownData();
    }, [])
    useEffect(() => {
        const today = new Date();
        const formattedToday = today.toISOString().split("T")[0];

        setPeriodFrom(formattedToday);
        setGridList({ ...gridList, transectionDate: formattedToday })
        const handleClickOutside = () => setContextMenu(null);
        window.addEventListener('click', handleClickOutside);
        return () => window.removeEventListener('click', handleClickOutside);

    }, [])
    useEffect(() => {
        setTransactionColDefs((prev) =>
            prev.map((row) => {
                const credit = parseFloat(row.credit || 0);
                const rate = row.taxCode?.value?.Rate || 0;

                let vat = 0;
                let total = 0;
                let creditAmount = 0;

                if (credit) {
                    if (taxInclusive) {
                        vat = (credit * rate) / 100;
                        total = credit;
                        creditAmount = credit - ((credit * rate) / 100);
                    } else {
                        vat = (credit * rate) / 100;
                        total = credit + vat;
                        creditAmount = credit;
                    }
                }

                return {
                    ...row,
                    vat: credit ? vat.toFixed(currencyPrecision?.decimalNumbers) : "",
                    total: credit ? total.toFixed(currencyPrecision?.decimalNumbers) : "",
                    creditAmount: credit ? creditAmount.toFixed(currencyPrecision?.decimalNumbers) : "",
                };
            })
        );
    }, [taxInclusive]);
    const fetchDropdownData = async () => {
        try {
            const params = new URLSearchParams();
            params.append('dropdownTypes', 'LGISerPropertyName,LGITransCurrency,LGIVoucherType,LGITransactionType,LGITenantNames,LGIAccountNames');
            const res = await apiService.getApiParamater('GET_GENERAL_MULTI', `?${params.toString()}`);
            setProperty(res?.data?.dropdowns?.LGISerPropertyName)
            setTransectionList(res?.data?.dropdowns?.LGITransType)
            setVoucherList(res?.data?.dropdowns?.LGIVoucherType)
            setCurrencyList(res?.data?.dropdowns?.LGITransCurrency)
            setTenantList(res?.data?.dropdowns?.LGITenantNames)
            setAccountList(res?.data?.dropdowns?.LGIAccountNames)
            const filteredDenominations = res?.data?.dropdowns?.LGITransCurrency?.find(currency => currency?.text === "1");
            if (filteredDenominations) {
                setSelectedCurency({ label: filteredDenominations.value, value: filteredDenominations });
            }
            const duductoinParam = new URLSearchParams();
            duductoinParam.append('Action', 'GetTaxDetails');
            const deductionRes = await apiService.getApiParamater('TERMINATION_COMMON', `?${duductoinParam.toString()}`);
            setTaxList(deductionRes?.data?.result?.data)

            const leaseData = new URLSearchParams();
            leaseData.append('Action', 'GetGenralInvoiceDetailsByVoucherno');
            leaseData.append('leaseNo', itemData?.voucherNo);
            debugger
            const leaseRes = await apiService.getApiParamater('GET_GENERAL_COMMON', `?${leaseData.toString()}`);
            const data = leaseRes?.data?.result?.data || [];
            if (!data.length) return;
            // Use first record for header fields
            const firstRecord = data[0];

            const tax = deductionRes?.data?.result?.data?.find(
                itm => itm?.RecordId === firstRecord?.TaxCode
            );

            setGridList({
                ...gridList,
                tanentNo: firstRecord?.TenantNo,
                transectionDate: firstRecord?.PostingDate,
                tenantName: firstRecord?.TenantName,
                conRate: "1.000",
                voucherType: {
                    label: firstRecord?.VoucherType || "",
                    value: firstRecord?.VoucherType
                },
                Proprty: firstRecord?.PropertyName,
                PropertyNo: firstRecord?.PropertyNo,
                amountDr: Number(firstRecord?.Total || 0).toFixed(currencyPrecision?.decimalNumbers),
                fxAmount: "0.000",
                transType: {
                    label: firstRecord?.Exp5 || "",
                    value: firstRecord?.Exp5
                },
                unitNo: firstRecord?.UnitNo || "",
                taxCode: {
                    label: tax?.Description || "",
                    value: tax
                },
                leaseNo: firstRecord?.LeaseNo,
                narration: "",
                UnitRefNo: firstRecord?.UnitRefNo
            });

            // Create grid rows (works for single & multiple objects)
            const formattedGrid = data.map(item => {
                const selectedAcc = res?.data?.dropdowns?.LGIAccountNames?.find(
                    acc => acc?.value === item?.CreditAcCode
                );

                const tax = deductionRes?.data?.result?.data?.find(
                    t => t?.RecordId === item?.TaxCode
                );

                return {
                    AccountCode: {
                        label: selectedAcc?.value || "",
                        value: selectedAcc
                    },
                    AccountName: {
                        label: selectedAcc?.text || "",
                        value: selectedAcc
                    },
                    taxCode: {
                        label: tax?.Description || "",
                        value: tax
                    },
                    credit: item?.Amount || "",
                    vat: item?.VAT || "",
                    total: item?.Total || "",
                    creditAmount: item?.Amount || "",
                    narration: item?.Remarks || "",
                    recordId: item?.RecordId
                };
            });

            setTransactionColDefs(formattedGrid);
        } catch (error) {
            console.error('Error fetching dropdown data:', error);
        }
    }
    const handleTabClick = (tabIndex) => {
        setActiveTab(tabIndex);
        const newGridVisibility = gridVisibility.map((_, index) => index === tabIndex);
        setGridVisibility(newGridVisibility);
    }
    const handleFileSelect = (event, id) => {
        const file = event.target.files[0];
        if (file) {
            setAttachmentList((prevList) => [
                ...prevList.map((attachment) => (attachment.id === id ? { ...attachment, fileName: file.name, file: file } : attachment)),
                { id: Date.now(), fileName: '', remarks: '' },
            ]);
        }
    }
    const handleView = (file) => {
        if (file && file instanceof File) {
            setPreviewImage(URL.createObjectURL(file));
            setPreviewModal(true);
        } else {
            console.error('No valid file to preview');
        }
    }
    const handleDelete = (id) => {
        const updatedList = attachmentList.filter((attachment) => attachment.id !== id);
        setAttachmentList(updatedList);
    }
    // Search Filter
    const handleClearFilters = () => {
        setFormData({
            Proprty: [{ label: 'Select Property', value: '' }],
            unitNo: [{ label: 'Select Unit No', value: '' }],
            tenantName: [{ label: 'Select Tenant', value: '' }],
            tenantNo: [{ label: 'Select Account Code', value: '' }],
        });
    }
    const handlePropertyChange = async (selectedOption) => {
        const params = new URLSearchParams();
        params.append('DropdownFor', 'LGIPopUpUnitsByPropId');
        params.append('CascadValue', selectedOption?.value?.value);
        const res = await apiService.getApiParamater('GET_GENERAL_CASCAD', `?${params.toString()}`);
        setUnitList(res?.data?.items || []);
        setFormData({
            ...formData,
            Proprty: selectedOption,
            unitNo: [{ label: 'select Unit No', value: '' }]
        });
    }
    const handleUitNo = (selectedOption) => {
        setFormData({ ...formData, unitNo: selectedOption });
    }
    const handleTenantName = (selectedOption) => {

        const selectedtanent = tenantList?.find(currency => currency?.text === selectedOption?.label);
        setFormData({
            ...formData,
            tenantName: selectedOption,
            tenantNo: [{ label: selectedtanent?.value, value: selectedtanent }]
        });
    }
    const handleTenantNo = (selectedOption) => {

        const selectedtanent = tenantList?.find(currency => currency?.value === selectedOption?.label);
        setFormData({
            ...formData,
            tenantNo: selectedOption,
            tenantName: [{ label: selectedtanent?.text, value: selectedtanent }]
        });
    }
    const handleSelectTenant = (tenant, index) => {
        setSelectedTenant(tenant);
        setGridList({
            ...gridList,
            tanentNo: tenant?.TenantNo,
            transectionDate: periodFrom,
            tenantName: tenant?.Tenant,
            conRate: "1.000",
            voucherType: "",
            Proprty: tenant?.PropertyName,
            fxAmount: "0.000",
            transectionType: "",
            unitNo: tenant?.UnitNo,
            amountDr: "0.000",
            taxCode: "",
            leaseNo: tenant?.LeaseNo,
            narration: "",
            tenant
        });
        setTenantData([{
            LeaseNo: "",
            Property_name: "",
            Unit_No: "--",
            rent: "--",
            TenantNo: "",
            TenantName: "",
            contactNo: "",
        }]);
        // handleClearFilters()
        setSearchModal(false);
    }
    const handleSearch = async () => {
        try {
            const duductoinParam = new URLSearchParams();
            duductoinParam.append('Action', 'GetLGIPopUpSerLeasedetails');
            duductoinParam.append('PropertyNo', formData?.Proprty?.value?.value || "All");
            duductoinParam.append('UnitNo', formData?.unitNo?.label || "All");
            duductoinParam.append('TenantNo', formData?.tenantNo?.label || "All");
            const deductionRes = await apiService.getApiParamater('GET_GENERAL_COMMON', `?${duductoinParam.toString()}`);
            let data = deductionRes?.data?.result?.data
            if (data?.length > 0) {
                setTenantData(data || []);
            } else {
                setTenantData([data] || []);
            }
        } catch (error) {
            console.error('Error fetching items:', error);
        }
    }
    const handlecurChange = (selectedOption) => {
        setSelectedCurency(selectedOption);
    }
    const formatDate = (date) => {
        if (!date) return null;
        const d = new Date(date);
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, '0'); // month is 0-based
        const day = String(d.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }
    const handleChange = async (key, value) => {
        try {
            if (key === "transectionDate") {
                const formattedDate = formatDate(value);
                setGridList({ ...gridList, transectionDate: formattedDate });
            } else if (key === "conRate") {
                setGridList({ ...gridList, conRate: value });
            } else if (key === "voucherType") {
                setGridList({ ...gridList, voucherType: value });
            } else if (key === "fxAmount") {
                setGridList({ ...gridList, fxAmount: value });
            } else if (key === "transType") {
                // taxCode
                const transParam = new URLSearchParams();
                transParam.append('Action', 'GetTaxcodeByTranIdAndLeaseNo');
                transParam.append('LeaseNo', gridList?.leaseNo);
                transParam.append('UnitRefNo', value?.value?.value);
                const deductionRes = await apiService.getApiParamater('GET_GENERAL_COMMON', `?${transParam.toString()}`);
                let taxCode = deductionRes?.data?.result?.data[0]?.Taxcode;
                const selectedTax = taxList?.find(currency => currency?.RecordId === taxCode);

                // Account Details
                const accountParam = new URLSearchParams();
                accountParam.append('Action', 'GetAccCodeByTranTypeAndPropName');
                accountParam.append('PropertyName', gridList?.Proprty);
                accountParam.append('UnitRefNo', value?.label);

                const accRes = await apiService.getApiParamater('GET_GENERAL_COMMON', `?${accountParam.toString()}`);
                let account = accRes?.data?.result?.data[0];
                const selectedAccount = accountList?.find(currency => currency?.text === account?.AccountName);

                // Update gridList
                setGridList({
                    ...gridList,
                    transType: value,
                    taxCode: { label: selectedTax?.Description, value: selectedTax }
                });

                // Update transactionColDefs at index 0
                setTransactionColDefs(prevList => {
                    const data = {
                        AccountCode: { label: selectedAccount?.value || "", value: selectedAccount || "" },
                        AccountName: { label: selectedAccount?.text || "", value: selectedAccount || "" },
                        taxCode: { label: selectedTax?.Description || "", value: selectedTax || "" },
                    };

                    if (!prevList || prevList.length === 0) {
                        return [data];
                    } else {
                        // update index 0
                        const newList = [...prevList];
                        newList[0] = data;
                        return newList;
                    }
                });
            } else if (key === "amountDr") {
                setGridList({ ...gridList, amountDr: value });
            } else if (key === "taxCode") {
                setGridList({ ...gridList, taxCode: value });
            } else if (key === "narration") {
                setGridList({ ...gridList, narration: value });
            }
        } catch (error) {
            console.error('Error fetching items:', error);
        }
    }
    const handleDeleteAlocate = (index) => {
        const updatedList = [...transactionColDefs];
        updatedList.splice(index, 1);
        setTransactionColDefs(updatedList);
    }
    const handleGridChange = (index, key, value) => {
        setTransactionColDefs((prev) => {
            const updatedList = [...prev];
            let row = { ...updatedList[index] };

            if (key === "AccountCode" || key === "AccountName") {
                row.AccountName = ({ label: value?.value?.text || "", value: value?.value || "" });
                row.AccountCode = ({ label: value?.value?.value || "", value: value?.value || "" })
            } else if (key === "taxCode") {
                row.taxCode = value;

                if (row.credit) {
                    const credit = parseFloat(row.credit || 0);
                    const rate = value?.value?.Rate || 0;

                    let vat = 0;
                    let total = 0;
                    let creditAmount = 0;

                    if (taxInclusive) {
                        vat = (credit * rate) / 100;
                        total = credit;
                        creditAmount = credit - ((credit * rate) / 100);
                    } else {
                        vat = (credit * rate) / 100;
                        total = credit + vat;
                        creditAmount = credit;
                    }

                    row.vat = vat.toFixed(currencyPrecision?.decimalNumbers);
                    row.total = total.toFixed(currencyPrecision?.decimalNumbers);
                    row.creditAmount = creditAmount.toFixed(currencyPrecision?.decimalNumbers);
                }
            } else if (key === "credit") {
                row.credit = value;

                const credit = parseFloat(value || 0);
                const rate = row.taxCode?.value?.Rate || 0;

                let vat = 0;
                let total = 0;
                let creditAmount = 0;

                if (taxInclusive) {
                    // Credit contains VAT already
                    vat = (credit * rate) / 100;
                    total = credit;
                    creditAmount = credit - ((credit * rate) / 100);
                } else {
                    // Credit excludes VAT
                    vat = (credit * rate) / 100;
                    total = credit + vat;
                    creditAmount = credit;
                }

                row.vat = vat.toFixed(currencyPrecision?.decimalNumbers);
                row.total = total.toFixed(currencyPrecision?.decimalNumbers);
                row.creditAmount = creditAmount.toFixed(currencyPrecision?.decimalNumbers);
            } else {
                row[key] = value;
            }

            updatedList[index] = row;
            return updatedList;
        });
    }
    const handleAddNew = () => {
        setTransactionColDefs(prev => [
            ...prev,
            {
                AccountCode: "",
                AccountName: "",
                credit: "",
                taxCode: "",
                vat: "",
                total: "",
                narration: "",
            }
        ]);
    }
    const handleSave = async () => {
        try {
            setloader(true);
            const currentDatetimeUTC = new Date().toISOString();
            if (!gridList?.leaseNo) {
                toast.warning(`Please Select Lease No`);
                setloader(false);
                return;
            } else if (transactionColDefs.length === 0) {
                toast.warning(`Please Select Lease No to Create Invoice`);
                setloader(false);
                return;
            } else if (!gridList?.tanentNo) {
                toast.warning(`Please add Account Code `);
                setloader(false);
                return;
            } else if (!gridList?.tenantName) {
                toast.warning(`Please add Tenant `);
                setloader(false);
                return;
            } else if (!gridList?.transType?.label) {
                toast.warning(`Please Select Transection Type`);
                setloader(false);
                return;
            } else if (!gridList?.voucherType?.label) {
                toast.warning(`Please Select  Type`);
                setloader(false);
                return;
            }
            let drAmount = parseFloat(gridList?.amountDr).toFixed(currencyPrecision?.decimalNumbers)
            if (total !== drAmount) {
                toast.warning("Cradit Amount and Debit Amount should be same.")
                setloader(false);
                return;
            }

            const lgAccountDetailsList = transactionColDefs?.map(item => {
                // if (item?.taxCode?.value?.VatAcCode === "0") {
                //   toast.warning("VAT account Code not defined please add VAT account")
                //   setloader(false)
                //   return
                // }
                let convertedAmount = (gridList?.conRate * item?.total)
                return {
                    recordId: item?.recordId || 0,
                    receiptNo: "0",
                    acCode: item?.AccountCode?.label,
                    acName: item?.AccountName?.label,
                    percentage: item?.taxCode?.value?.Rate || 0,
                    credit: parseFloat(item?.creditAmount),
                    taxCode: item?.taxCode?.value?.RecordId || 0,
                    vat: parseFloat(item?.vat),
                    st: 0,
                    total: parseFloat(item?.total),
                    conRate: parseFloat(gridList?.conRate)?.toFixed(currencyPrecision?.decimalNumbers),
                    convertedAmount: parseFloat(convertedAmount)?.toFixed(currencyPrecision?.decimalNumbers),
                    narration: item?.narration || "0",
                    costCenter1: gridList?.Proprty,
                    costCenter2: gridList?.unitNo,
                    costCenter3: "0",
                    costCenter4: "0",
                    costCenter5: "0",
                    vatAcCode: item?.taxCode?.value?.VatAcCode || 0,
                    stAcCode: "0",
                    exp1: "0",
                    exp2: "0",
                    exp3: "0",
                    modifiedBy: userName,
                    modifiedOn: currentDatetimeUTC,
                    createdBy: userName,
                    createdOn: currentDatetimeUTC,
                    taxDescription: item?.taxCode?.value?.Description || 0,
                    taxRate: item?.taxCode?.value?.Rate || 0,
                }
            });
            let rate = gridList?.taxCode?.value?.Rate
            const vat = (parseFloat((gridList.amountDr) * rate) / 100);
            let totl = (parseFloat(gridList?.amountDr) + vat)
            const leaseGeneralInvoice = {
                recordId: itemData?.recordId,
                leaseNo: gridList?.leaseNo,
                propertyName: gridList?.Proprty,
                propertyNo: formData?.Proprty?.value?.value || gridList?.tenant?.PropertyNo || gridList?.PropertyNo,
                unitNo: gridList?.unitNo,
                unitRefNo: gridList?.tenant?.UnitRefNo || gridList?.UnitRefNo,
                tenantNo: gridList?.tenant?.TenantNo || gridList?.tanentNo,
                tenantName: gridList?.tenant?.Tenant || gridList?.tenantName,
                voucherType: gridList?.voucherType?.label,
                psId: 0,
                paymentType: "0",
                amount: parseFloat(gridList?.amountDr)?.toFixed(currencyPrecision?.decimalNumbers),
                vatPercent: gridList?.taxCode?.value?.Rate,
                vat: parseFloat(vat)?.toFixed(currencyPrecision?.decimalNumbers),
                stPercent: 0,
                st: 0,
                total: parseFloat(gridList?.amountDr)?.toFixed(currencyPrecision?.decimalNumbers),
                amountReceived: 0,
                dueDate: "2025-10-06T12:03:35.447Z",
                postingDate: "2025-10-06T12:03:35.447Z",
                postingId: "0",
                voucherNo: itemData?.voucherNo,
                financialYear: activeFY,
                debitAcCode: gridList?.tanentNo,
                creditAcCode: transactionColDefs[0]?.AccountCode?.label,
                tranId: itemData?.tranId,
                category: itemData?.category,
                taxCode: gridList?.taxCode?.value?.RecordId,
                remarks: gridList?.narration || "0",
                isApproved: true,
                approvedDate: currentDatetimeUTC,
                approvedBy: "0",
                exp1: "0",
                exp2: "0",
                exp3: "0",
                exp4: "0",
                exp5: "0",
                modifiedBy: userName,
                modifiedOn: currentDatetimeUTC,
                createdBy: userName,
                createdOn: currentDatetimeUTC,
                leaseFromDate: "2025-10-06T12:03:35.447Z",
                leaseToDate: "2025-10-06T12:03:35.447Z",
                transactionDate: moment(gridList?.transectionDate).format("YYYY-MM-DDTHH:mm:ss")
            };

            const leaseAttachmentList = [
                {
                    recordId: 0,
                    leaseNo: "string",
                    description: "string",
                    description_BI: "string",
                    filename: "string",
                    folder: "string",
                    exp1: "string",
                    exp2: "string",
                    exp3: "string",
                    modifiedBy: "string",
                    modifiedOn: "2025-10-06T13:05:28.632Z",
                    createdBy: "string",
                    createdOn: "2025-10-06T13:05:28.632Z",
                    docPic: "string",
                    clearDocImage: true
                }
            ]

            const body = {
                generalInvoiceMain: {
                    leaseGeneralInvoice: leaseGeneralInvoice,
                    lgAccountDetailsList: lgAccountDetailsList,
                    // leaseAttachmentList: leaseAttachmentList,
                    mode: "EDIT",
                    modalPropertyName: gridList?.Proprty,
                    modalUnitNo: gridList?.unitNo,
                    modalTenantNo: gridList?.tanentNo,
                    modalTenantName: gridList?.tenantName,
                    modalOutletName: "0",
                    frmTenantNo: gridList?.tanentNo,
                    frmTenantName: gridList?.tenantName,
                    frmPropertyName: gridList?.Proprty,
                    frmUnitNo: gridList?.unitNo,
                    frmLeaseNo: gridList?.leaseNo,
                    frmCurrency: SelectedCurrency?.label,
                    frmVoucherType: gridList?.voucherType?.label,
                    frmTaxCode: gridList?.taxCode?.value?.RecordId,
                    frmConversionRate: parseFloat(gridList?.conRate)?.toFixed(currencyPrecision?.decimalNumbers),
                    frmFxAmount: parseFloat(gridList?.fxAmount)?.toFixed(currencyPrecision?.decimalNumbers),
                    frmTransactionDate: moment(gridList?.transectionDate).format("YYYY-MM-DDTHH:mm:ss"),
                    frmReceiptNo: "0",
                    transactionType: gridList?.transType?.label,
                    frmInvoiceRefNo: "0",
                },
            };
            debugger
            const postRes = await apiService.post("POST_GENERAL", body);

            if (postRes?.data?.statusCode === 201 || postRes?.data?.statusCode === 20) {
                toast.success(`General Invoice Created successfully`);
                setloader(false);
                handleClearFilters()
                if (onSaved) {
                    onSaved();
                } else if (onClose) {
                    onClose();
                } else {
                    navigate("/Property/Management/Lease/GeneralInvoice/listing");
                }
            } else {
                toast.error(postRes?.data?.message)
                setloader(false);
            }
        } catch (error) {
            setloader(false);
            console.error("Error Save Data", error);
        }
    }
    const handleApplyToRows = () => {
        if (!gridList?.taxCode) return;

        setTransactionColDefs((prev) =>
            prev.map((row) => {
                const rate = gridList.taxCode?.value?.Rate || 0;
                const credit = parseFloat(row.credit || 0);

                let vat = 0;
                let total = 0;
                let creditAmount = 0;

                if (taxInclusive) {
                    // Credit contains VAT already
                    vat = (credit * rate) / 100;
                    total = credit;
                    creditAmount = credit - ((credit * rate) / 100);
                } else {
                    // Credit excludes VAT
                    vat = (credit * rate) / 100;
                    total = credit + vat;
                    creditAmount = credit;
                }

                return {
                    ...row,
                    taxCode: gridList.taxCode,
                    vat: credit ? vat.toFixed(currencyPrecision?.decimalNumbers) : "",
                    total: credit ? total.toFixed(currencyPrecision?.decimalNumbers) : "",
                    creditAmount: credit ? creditAmount.toFixed(currencyPrecision?.decimalNumbers) : "",
                };
            })
        );
    };
    return (
        <Modal show={show} onHide={handleBackClick} size="xl" scrollable centered backdrop="static" keyboard={false}>
            <Modal.Header closeButton>
                <Modal.Title>Edit General Invoice</Modal.Title>
            </Modal.Header>
            <Modal.Body>
            <div className="border-box2 p-2" style={{ borderRadius: '8px' }}>
                <div className="end">
                    <div className="d-flex gap-2 ">
                        {loader === true ? (
                            <div className="mainbtn flex-end gap-2 w-50">
                                <ClipLoader color="#ffffff" className="mt-1" size={25} />
                            </div>
                        ) : (
                            <div className="mainbtn flex-end gap-2 w-50" onClick={handleSave}>
                                <FaSave color="#fff" className="center mt-2 mx-2" />
                                <div className="center">Save</div>
                            </div>
                        )}
                        <div className="mainbtnSecondary flex-end gap-2 w-50" onClick={handleBackClick}>
                            <FaChevronLeft color="#fff" className="center mt-1 mx-2" />
                            <div className="center">Back</div>
                        </div>
                        <div className="mainbtnRed flex-end gap-2 w-50">
                            <RiRefreshLine color="#fff" className="center mt-1 mx-2" />
                            <div className="center">Reset</div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="border-box2 my-3 p-3" style={{ borderRadius: '8px' }}>
                <div className="nav nav-pills overslid d-flex gap-4">
                    <div className={`dashitems sidebar-text center ${activeTab === 0 ? 'sideActive' : ''}`} onClick={() => handleTabClick(0)}>
                        Transaction Details
                    </div>
                    <div className={`dashitems sidebar-text center ${activeTab === 1 ? 'sideActive' : ''}`} onClick={() => handleTabClick(1)}>
                        Attachments
                    </div>
                </div>
            </div>
            {gridVisibility[0] && (
                <div className="border-box2 p-3" style={{ borderRadius: '8px' }}>
                    <div className="form-group mb-3 grid-contain ">
                        <div className="d-flex">
                            <label htmlFor="accountCode" className="form-label pt-1 start">Account Code</label>
                            <input type="text" className="p-2 form-control w-75" readOnly value={gridList?.tanentNo} />
                            <button className="mainbtn center ms-2 px-2" onClick={() => setSearchModal(true)}>
                                <IoSearch color="#fff" />
                            </button>
                        </div>
                        <div className="d-flex">
                            <label htmlFor="currency" className="form-label pt-1 start">
                                Currency
                            </label>
                            <Select
                                theme={(theme) => ({
                                    ...theme,
                                    borderRadius: 5,
                                    padding: 9,
                                })}
                                menuPortalTarget={document.body}
                                styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    option: (provided, state) => ({
                                        ...provided,
                                        backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                        color: state.isFocused ? '#000 ' : '#000',
                                        ':hover': {
                                            backgroundColor: '#F5F5F5',
                                            color: '#000 ',
                                        },
                                    }),
                                }}
                                className="w-75 p-0"
                                value={SelectedCurrency}
                                onChange={(e) => handlecurChange(e)}
                                options={currencyList?.map((rec) => ({ value: rec, label: rec?.value }))}
                            />
                        </div>
                        <div className="d-flex">
                            <label htmlFor="transactionDate" className="form-label pt-1 start">
                                Transaction Date
                            </label>
                            <DatePicker
                                todayButton="Today"
                                selected={gridList?.transectionDate}
                                onChange={(date) => handleChange('transectionDate', date)}
                                dateFormat="dd-MMM-yyyy"
                                className="p-2 form-control w-100"
                            />
                        </div>
                        <div className="d-flex">
                            <label htmlFor="tenant" className="form-label pt-1 start">
                                Tenant
                            </label>
                            <input type="text" className="p-2 form-control w-75" readOnly value={gridList?.tenantName} />
                        </div>
                        <div className="d-flex">
                            <label htmlFor="conRate" className="form-label pt-1 start">
                                Con Rate
                            </label>
                            <input type="text" className="p-2 form-control w-75"
                                onChange={(e) => handleChange("conRate", e.target.value)} readOnly defaultValue="1.000" value={gridList?.conRate} />
                        </div>
                        <div className="d-flex">
                            <label htmlFor="type" className="form-label pt-1 start">
                                Type
                            </label>
                            <Select
                                theme={(theme) => ({
                                    ...theme,
                                    borderRadius: 5,
                                    padding: 9,
                                })}
                                menuPortalTarget={document.body}
                                styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    option: (provided, state) => ({
                                        ...provided,
                                        backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                        color: state.isFocused ? '#000 ' : '#000',
                                        ':hover': {
                                            backgroundColor: '#F5F5F5',
                                            color: '#000 ',
                                        },
                                    }),
                                }}
                                className="w-75 p-0"
                                value={gridList?.voucherType}
                                onChange={(selectedOption) => handleChange("voucherType", selectedOption)}
                                options={voucherList?.map((rec) => ({ value: rec, label: rec?.value }))}
                            />
                        </div>
                        <div className="d-flex">
                            <label htmlFor="property" className="form-label pt-1 start">
                                Property
                            </label>
                            <input type="text" className="p-2 form-control w-75" readOnly name="property" value={gridList?.Proprty} />
                        </div>
                        <div className="d-flex">
                            <label htmlFor="fxAmount" className="form-label pt-1 start">
                                Fx Amount
                            </label>
                            <input type="text" className="p-2 form-control w-75"
                                onChange={(e) => handleChange("fxAmount", e.target.value)} defaultValue="0.0000" value={gridList?.fxAmount} />
                        </div>
                        <div className="d-flex">
                            <label htmlFor="transactionType" className="form-label pt-1 start">
                                Transaction Type
                            </label>
                            <Select
                                theme={(theme) => ({
                                    ...theme,
                                    borderRadius: 5,
                                    padding: 9,
                                })}
                                menuPortalTarget={document.body}
                                styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    option: (provided, state) => ({
                                        ...provided,
                                        backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                        color: state.isFocused ? '#000 ' : '#000',
                                        ':hover': {
                                            backgroundColor: '#F5F5F5',
                                            color: '#000 ',
                                        },
                                    }),
                                }}
                                className="w-75 p-0"
                                value={gridList?.transType}
                                onChange={(selectedOption) => handleChange("transType", selectedOption)}
                                options={TransectionList?.map((rec) => ({ value: rec, label: rec?.text }))}
                            />
                        </div>
                        <div className="d-flex">
                            <label htmlFor="unitNo" className="form-label pt-1 start">Unit No              </label>
                            <input type="text" className="p-2 form-control w-75" readOnly value={gridList?.unitNo} />
                        </div>
                        <div className="d-flex">
                            <label htmlFor="amountDr" className="form-label pt-1 start">
                                Amount (Dr)
                            </label>
                            <input type="text" className="p-2 form-control w-75"
                                onChange={(e) => handleChange("amountDr", e.target.value)}
                                defaultValue="0.000" value={gridList?.amountDr} />
                        </div>
                        <div className="d-flex">
                            <label htmlFor="taxCode" className="form-label pt-1 start">Tax Code</label>
                            <WindowedSelect
                                className="w-100  p-0"
                                theme={(theme) => ({
                                    ...theme,
                                    borderRadius: 5,
                                    padding: 9
                                })}

                                menuPortalTarget={document.body}
                                menuPlacement="auto"
                                menuShouldScrollIntoView={false}
                                styles={{
                                    menuPortal: base => ({ ...base, zIndex: 9999 }),
                                    option: (provided, state) => ({
                                        ...provided,
                                        backgroundColor: state.isFocused ? '#F5F5F5' : null,
                                        color: '#000',
                                        ':hover': {
                                            backgroundColor: '#F5F5F5',

                                            color: '#000',
                                        },
                                    }),
                                }}

                                value={gridList.taxCode}
                                onChange={(selectedOption) => handleChange("taxCode", selectedOption)}
                                options={taxList?.map((rec) => ({ value: rec, label: rec?.Description }))}
                            />
                        </div>
                        <div className="d-flex">
                            <label htmlFor="leaseNo" className="form-label pt-1 start">Lease No</label>
                            <input type="text" className="p-2 form-control w-75" value={gridList?.leaseNo} readOnly />
                        </div>
                        <div className="d-flex align-items-center gap-2">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                id="taxInclusive"
                                checked={taxInclusive}
                                onChange={(e) => setTaxInclusive(e.target.checked)}
                                style={{ width: '20px', height: '20px' }}
                            />
                            <label className="form-check-label" htmlFor="taxInclusive">
                                Tax Inclusive
                            </label>
                            <button className="mainbtnSecondary ms-auto px-3" onClick={handleApplyToRows}>Apply To Rows</button>
                        </div>
                    </div>

                    <div className="mb-2">
                        <label htmlFor="narration" className="form-label start">
                            Narration
                        </label>
                        <textarea className="form-control" id="narration"
                            onChange={(e) => handleChange("narration", e.target.value)} rows="2" value={gridList?.narration}></textarea>
                    </div>

                    <div className="border-box2 mt-2 p-3" style={{ borderRadius: '8px' }}>
                        <div className='table-container' style={{ overflowX: 'auto', height: "400px" }}>
                            <table className='table table-bordered gridshad'>
                                <thead className='dynoTable'>
                                    <tr>
                                        <th>Action</th>
                                        <th>Account Code</th>
                                        <th>Account Name</th>
                                        <th>Amount</th>
                                        <th>Tax</th>
                                        <th>Credit</th>
                                        <th>VAT</th>
                                        <th>Total</th>
                                        <th>Narration</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {Array.isArray(transactionColDefs) && transactionColDefs.map((data, index) => {
                                        return (
                                            <tr key={index}>
                                                <td className="text-center">
                                                    <div className='center mt-2'>
                                                        <FaTrash
                                                            size={20}
                                                            style={{ cursor: "pointer", color: "red" }}
                                                            onClick={() => handleDeleteAlocate(index)}
                                                        />
                                                    </div>
                                                </td>
                                                <td>
                                                    <div style={{ width: "200px" }}>
                                                        <WindowedSelect
                                                            className="w-100  p-0"
                                                            theme={(theme) => ({
                                                                ...theme,
                                                                borderRadius: 5,
                                                                padding: 9
                                                            })}

                                                            menuPortalTarget={document.body}
                                                            menuPlacement="auto"
                                                            menuShouldScrollIntoView={false}
                                                            styles={{
                                                                menuPortal: base => ({ ...base, zIndex: 9999 }),
                                                                option: (provided, state) => ({
                                                                    ...provided,
                                                                    backgroundColor: state.isFocused ? '#F5F5F5' : null,
                                                                    color: '#000',
                                                                    ':hover': {
                                                                        backgroundColor: '#F5F5F5',

                                                                        color: '#000',
                                                                    },
                                                                }),
                                                            }}

                                                            value={data.AccountCode}
                                                            onChange={(selectedOption) => handleGridChange(index, "AccountCode", selectedOption)}
                                                            options={accountList?.map((rec) => ({ value: rec, label: rec?.value }))}
                                                        />
                                                    </div>
                                                </td>
                                                <td>
                                                    <div style={{ width: "200px" }}>
                                                        <WindowedSelect
                                                            className="w-100  p-0"
                                                            theme={(theme) => ({
                                                                ...theme,
                                                                borderRadius: 5,
                                                                padding: 9
                                                            })}

                                                            menuPortalTarget={document.body}
                                                            menuPlacement="auto"
                                                            menuShouldScrollIntoView={false}
                                                            styles={{
                                                                menuPortal: base => ({ ...base, zIndex: 9999 }),
                                                                option: (provided, state) => ({
                                                                    ...provided,
                                                                    backgroundColor: state.isFocused ? '#F5F5F5' : null,
                                                                    color: '#000',
                                                                    ':hover': {
                                                                        backgroundColor: '#F5F5F5',

                                                                        color: '#000',
                                                                    },
                                                                }),
                                                            }}

                                                            value={data.AccountName}
                                                            onChange={(selectedOption) => handleGridChange(index, "AccountName", selectedOption)}
                                                            options={accountList?.map((rec) => ({ value: rec, label: rec?.text }))}
                                                        />
                                                    </div>
                                                </td>

                                                <td><input value={data?.credit} className='p-1' onChange={(e) => handleGridChange(index, "credit", e.target.value)} /></td>
                                                <td>
                                                    <div style={{ width: "200px" }}>
                                                        <WindowedSelect
                                                            className="w-100  p-0"
                                                            theme={(theme) => ({
                                                                ...theme,
                                                                borderRadius: 5,
                                                                padding: 9
                                                            })}

                                                            menuPortalTarget={document.body}
                                                            menuPlacement="auto"
                                                            menuShouldScrollIntoView={false}
                                                            styles={{
                                                                menuPortal: base => ({ ...base, zIndex: 9999 }),
                                                                option: (provided, state) => ({
                                                                    ...provided,
                                                                    backgroundColor: state.isFocused ? '#F5F5F5' : null,
                                                                    color: '#000',
                                                                    ':hover': {
                                                                        backgroundColor: '#F5F5F5',

                                                                        color: '#000',
                                                                    },
                                                                }),
                                                            }}

                                                            value={data.taxCode}
                                                            onChange={(selectedOption) => handleGridChange(index, "taxCode", selectedOption)}
                                                            options={taxList?.map((rec) => ({ value: rec, label: rec?.Description }))}
                                                        />
                                                    </div>
                                                </td>
                                                <td><input value={data?.creditAmount} className='p-1' disabled /></td>
                                                <td><input value={data?.vat} className='p-1' disabled /></td>
                                                <td><input value={data?.total} className='p-1' disabled /></td>
                                                <td><input value={data?.narration} className='p-1' onChange={(e) => handleGridChange(index, "narration", e.target.value)} /></td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                            <div className="row p-0 m-0">
                                <div className="mainbtn col-2 gap-2" onClick={handleAddNew} style={{ cursor: 'pointer' }}>
                                    <MdAdd color="#fff" className="center mt-1 mx-2" />
                                    <div className="center">Add New</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className=" mt-1" >
                        <div className='d-flex justify-content-between boxs' style={{ borderRadius: '8px', padding: '10px' }}>
                            <div className='d-flex gap-2'>
                                <div className="totalhead center">Total Credit </div>
                                <div className='field'>{credit || "---"}</div>
                            </div>
                            <div className='d-flex gap-2'>
                                <div className="totalhead center">Total VAT </div>
                                <div className='field'>{vat || "---"}</div>
                            </div>
                            <div className='d-flex gap-2'>
                                <div className="totalhead center">Total Amount</div>
                                <div className='field'>{total || "---"}</div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {gridVisibility[1] && (
                <div className="border-box2 p-4" style={{ borderRadius: '8px' }}>
                    <div className="col d-flex justify-content-between">
                        <input className="form-Input w-100" placeholder="Enter Description" />
                    </div>
                    <div className="pt-2">
                        <table>
                            <thead className="dynoTable">
                                <tr>
                                    <th>File Name</th>
                                    <th>Remarks</th>
                                    <th>Upload</th>
                                    <th>View</th>
                                    <th>Delete</th>
                                </tr>
                            </thead>
                            <tbody>
                                {attachmentList?.map((attachment, index) => (
                                    <tr key={attachment.id}>
                                        <td className='m-0 p-0 col-6'><input className='p-0 mt-2' type='text' disabled value={attachment.fileName} style={{ width: "100%" }} /></td>
                                        <td className=' col-6'>
                                            <input type="text" className='p-0 mt-2' value={attachment.remarks}
                                                onChange={(e) => {
                                                    const updatedList = attachmentList?.map((item) =>
                                                        item.id === attachment.id ? { ...item, remarks: e.target.value } : item
                                                    );
                                                    setAttachmentList(updatedList);
                                                }}
                                                style={{ width: '100%' }}
                                            />
                                        </td>
                                        <td>
                                            <button className='mainbtn mt-2' onClick={() => document.getElementById(`fileInput-${attachment.id}`).click()} type="submit"><div>Upload</div></button>
                                            <input
                                                type="file" className='p-0'
                                                style={{ display: 'none' }}
                                                onChange={(e) => handleFileSelect(e, attachment.id)}
                                                id={`fileInput-${attachment.id}`}
                                                accept=".png,.jpg,.jpeg,.gif,.bmp,.pdf,.doc,.docx"
                                            />
                                        </td>
                                        <td><button className='mainbtnRed mt-2 mx-2 ' onClick={() => handleView(attachment.file)} disabled={!attachment.fileName}>
                                            <div>View</div></button></td>
                                        <td>
                                            <button onClick={() => handleDelete(attachment.id)} disabled={!attachment.fileName} className='mainbtnSecondary mt-2'>
                                                <div>Delete</div></button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            )}
            <Modal show={previewModal} size="lg" onHide={() => setPreviewModal(false)} centered backdrop="static" keyboard={false}>
                <Modal.Header closeButton>
                    <Modal.Title>Image Preview</Modal.Title>
                </Modal.Header>
                <Modal.Body>{previewImage && <img src={previewImage} alt={previewImage} style={{ width: '100%', objectFit: 'cover' }} />}</Modal.Body>
            </Modal>
            <Modal show={searchModal} size="lg" onHide={() => setSearchModal(false)} centered backdrop="static" keyboard={false}>
                <Modal.Header closeButton>
                    <Modal.Title>Search Tenant</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="border-box2 p-3" style={{ borderRadius: '8px' }}>
                        <div className="form-group mb-3" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: '20px' }}>
                            <div className="">
                                <label htmlFor="unit" className="form-label pt-1 start">Property No</label>
                                <WindowedSelect
                                    className="w-100  p-0"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}

                                    menuPortalTarget={document.body}
                                    menuPlacement="auto"
                                    menuShouldScrollIntoView={false}
                                    styles={{
                                        menuPortal: base => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5' : null,
                                            color: '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',

                                                color: '#000',
                                            },
                                        }),
                                    }}

                                    value={formData.Proprty}
                                    onChange={(selectedOption) => handlePropertyChange(selectedOption)}
                                    options={proprtyList?.map((rec) => ({ value: rec, label: rec?.text }))}
                                />
                            </div>
                            <div className="">
                                <label htmlFor="unit" className="form-label pt-1 start">Unit</label>
                                <WindowedSelect
                                    className="w-100  p-0"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}

                                    menuPortalTarget={document.body}
                                    menuPlacement="auto"
                                    menuShouldScrollIntoView={false}
                                    styles={{
                                        menuPortal: base => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5' : null,
                                            color: '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',

                                                color: '#000',
                                            },
                                        }),
                                    }}

                                    value={formData.unitNo}
                                    onChange={(selectedOption) => handleUitNo(selectedOption)}
                                    options={unitList?.map((rec) => ({ value: rec, label: rec?.text }))}
                                />
                            </div>
                            <div className="">
                                <label htmlFor="unit" className="form-label pt-1 start">Tenant Name</label>
                                <WindowedSelect
                                    className="w-100  p-0"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}

                                    menuPortalTarget={document.body}
                                    menuPlacement="auto"
                                    menuShouldScrollIntoView={false}
                                    styles={{
                                        menuPortal: base => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5' : null,
                                            color: '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',

                                                color: '#000',
                                            },
                                        }),
                                    }}

                                    value={formData.tenantName}
                                    onChange={(selectedOption) => handleTenantName(selectedOption)}
                                    options={tenantList?.map((rec) => ({ value: rec, label: rec?.text }))}
                                />
                            </div>
                            <div className="">
                                <label htmlFor="unit" className="form-label pt-1 start">Account Code</label>
                                <WindowedSelect
                                    className="w-100  p-0"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}

                                    menuPortalTarget={document.body}
                                    menuPlacement="auto"
                                    menuShouldScrollIntoView={false}
                                    styles={{
                                        menuPortal: base => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5' : null,
                                            color: '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',

                                                color: '#000',
                                            },
                                        }),
                                    }}

                                    value={formData.tenantNo}
                                    onChange={(selectedOption) => handleTenantNo(selectedOption)}
                                    options={tenantList?.map((rec) => ({ value: rec, label: rec?.value }))}
                                />
                            </div>
                            <div className="mainbtnGry gap-2" onClick={handleSearch}>
                                <IoSearch color="#fff" className="center mt-1 mx-2" />
                                <div className="center">Search</div>
                            </div>
                            <div className="mainbtnRed gap-2" onClick={handleClearFilters}>
                                <RiRefreshLine color="#fff" className="center mt-1 mx-2" />
                                <div className="center">Reset</div>
                            </div>
                        </div>
                    </div>
                    <div className="border-box2 mt-2 p-3" style={{ borderRadius: '8px' }}>
                        <div className='table-container' style={{ overflowX: 'auto', height: "300px" }}>
                            <table className='table table-bordered gridshad'>
                                <thead className='dynoTable'>
                                    <tr>
                                        <th>Action</th>
                                        <th>Lease No</th>
                                        <th>Property</th>
                                        <th>Unit No</th>
                                        <th>Rent</th>
                                        <th>Tenant No</th>
                                        <th>Tenant Name</th>
                                        <th>Contact No</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {Array.isArray(TenantData) && TenantData.map((data, index) => {
                                        return (
                                            <tr key={index}>
                                                <td className="text-center">
                                                    <div className='center text-center'>
                                                        <input className='mt-2'
                                                            type="radio" style={{ height: "20px", width: "20px" }}
                                                            name="tenantSelect"
                                                            onChange={() => handleSelectTenant(data, index)}
                                                        />
                                                    </div>
                                                </td>
                                                <td><input value={data?.LeaseNo} className='p-1' disabled /></td>
                                                <td><input value={data?.PropertyName} className='p-1' disabled /></td>
                                                <td><input value={data?.UnitNo} className='p-1' disabled /></td>
                                                <td><input value={data?.Total} className='p-1' disabled /></td>
                                                <td><input value={data?.TenantNo} className='p-1' disabled /></td>
                                                <td><input value={data?.Tenant} className='p-1' disabled /></td>
                                                <td><input value={data?.ContactNo} className='p-1' disabled /></td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div>
                        <button className="mainbtnSecondary ms-auto px-3" onClick={() => setSearchModal(false)}>Close</button>
                    </div>
                </Modal.Footer>
            </Modal>
            </Modal.Body>
        </Modal>
    );
};

export default LeaseGeneralInvoiceEdit;
